import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';
import { ChangePasswordMFAComponent } from './change-password-mfa/change-password-mfa.component';
import { ChangePasswordMFAStepTwoComponent } from './change-password-mfa-step-two/change-password-mfa-step-two.component';
import { ChangePassword2FAComponent } from '../../change-password-2-fa/change-password-2-fa.component';
import { ChangePasswordAuthAppComponent } from '../../change-password-auth-app/change-password-auth-app.component';



@NgModule({
  declarations: [
    ChangePasswordComponent,
    ChangePasswordMFAComponent,
    ChangePassword2FAComponent,
    ChangePasswordAuthAppComponent,
    ChangePasswordMFAStepTwoComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class ChangePasswordModule { }
